<div class="box">
  @if (!showRules) {
    <div class="pr-u-displayFlex pr-u-flexDirectionColumn pr-u-alignItemsCenter pr-u-textCenter pr-u-gap150">
      <div>
        <img src="assets/icons/icon-lucca.png" height="40" width="40" alt="" />
        <h2>La Quête des Luccasiens</h2>
      </div>
      <p class="pr-u-h4">Bienvenue, voyageur, au&nbsp;Royaume&nbsp;de&nbsp;Lucca&nbsp;!</p>
      <p>
        Perdez-vous dans la forêt enchantée, partez à la rencontre de 9 habitants légendaires du royaume, aidez-les
        grâce aux Principes Luccasiens et obtenez une récompense.
      </p>
      <button type="button" luButton (click)="store.startGame()">Commencer la quête</button>
      <button type="button" luButton="outlined" palette="product" (click)="toggleRules()">Consulter les règles</button>
    </div>
  } @else {
    <div class="pr-u-displayFlex pr-u-flexDirectionColumn pr-u-alignItemsCenter pr-u-textCenter pr-u-gap200">
      <div>
        <img src="assets/icons/icon-lucca.png" height="40" width="40" alt="" />
        <h2 class="pr-u-marginBlockEnd100">Règles du jeu</h2>
        <ol class="pr-u-textLeft">
          <li>Scannez les objets magiques (QR&nbsp;Codes) dissimulés dans la forêt.</li>
          <li>Répondez aux questions de chaque personnage.</li>
          <li>Une fois vos épreuves complétées, présentez-vous à un conseiller Luccasien pour valider vos réponses.</li>
        </ol>
      </div>
      <div>
        <h3 class="pr-u-marginBlockEnd50">Les récompenses</h3>
        <ul class="pr-u-textLeft">
          <li>Accomplissez la quête et vous aurez une récompense.</li>
          <li>Réussissez les 9 épreuves et participez au tirage au sort pour une autre, qui sera légeeendaire !</li>
        </ul>
      </div>
      <p>Envie de rejouer ? Les questions se renouvellent à chaque tentative.</p>
      <button type="button" luButton (click)="store.startGame()">Commencer la quête</button>
    </div>
  }
</div>
